<div class="dc-toast__wrapper {{config.type}} {{config.position}} {{config.effect}}">
  <div class="dc-toast">
    <div class="dc-toast__message">
      <span>{{config.message}}</span>
    </div>
    <span class="dc-toast__close" (click)="close()"></span>
  </div>
</div>
